<template>
  <div>
    <v-img
      src="@/assets/fondo.png"
      :height="imagenHeight"
      class="d-flex align-center"
      cover
    >
      <!-- Contenedor full-width dentro de la imagen -->
      <v-container fluid class="pa-0">
        <div :style="{ marginTop: espaciadoSuperior }"></div>
        <div class="text-center white--text px-3">
          <!-- Título grande -->
          <h1 class="titulo-principal mb-6">{{ $t('reservaTuPlaza') }}</h1>

          <div class="prueba1">
            <!-- Leyenda flotando encima del borde -->
            <h1 class="prueba2">{{ $t('eligeSitioIdeal') }}</h1>

            <!-- Contenedor de las dos v-select -->
            <div class="selects-container">
              <v-select
                style="text-align: center;"
                v-model="ciudadSeleccionada"
                :items="itemsCiudad"
                append-icon=""
                :placeholder="$t('ciudad')"
                flat
                hide-details
                class="mi-select select-item pa-3"
              />
              <v-select
                style="text-align: center;"
                v-model="parkingseleccionado"
                :items="itemsParkings"
                placeholder="Parking"
                :disabled="ciudadSeleccionada == ''"
                append-icon=""
                flat
                hide-details
                class="mi-select select-item pa-3"
              />
            </div>
          </div>
        </div>
      </v-container>
    </v-img>

    <!-- 3 tarjetas -->
    <v-container fluid class="mt-8 px-3">
      <v-row justify="center" dense>
        <v-col v-for="t in tarjetas" :key="t.titulo" cols="12" sm="8" md="3">
          <div class="mx-auto">
            <center>
              <v-icon color="#fad063" size="60">{{ t.icono }}</v-icon>
              <div class="fina margeninferior" style="color: black;font-size: larger;">
                {{ $t(t.titulo) }}
              </div>
              <div class="fina" style="color: #66777c">
                {{ $t(t.descripcion) }}
              </div>
            </center>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Descripcion parking -->
    <v-container align="start" justify="start" class="px-3">
      <v-row style="border-bottom: 1px solid #fad063; border-top: 1px solid #fad063">
        <v-col style="font-weight: 300;" class="ma-3 ma-md-6">
          <p class="text-justify-center" align="center">
            <span>{{ $t("descripcionParkingP1") }}</span>
          </p>
          <p class="text-justify-center" align="center">{{ $t("descripcionParkingP2") }}</p>
          <p class="text-justify-center" align="center">{{ $t("descripcionParkingP3") }}</p>
          <p class="text-justify-center" align="center">{{ $t("descripcionParkingP4") }}</p>
          <p class="text-justify-center" align="center">{{ $t("descripcionParkingP5") }}</p>
        </v-col>
      </v-row>
    </v-container>

    <!-- tabla de servicios y características del parking -->
    <v-container class="mt-6 px-3">
      <v-row align="stretch" justify="center" class="pa-0">
        <v-col
          class="col-md-3 col-sm-6 col-6 columna d-flex"
          style="flex-direction: column"
          v-for="(servicio, index) in serviciosParking"
          :key="index"
        >
          <div class="tarjeta flex-grow-1" align="center" justify="center" width="100%">
            <v-img
              height="50"
              :contain="true"
              :src="require(`@/assets/servicios/${servicio.icono}`)"
            />
            <v-row class="infoAdicionaltarjeta" align="center" justify="center" style="padding: 10px">
              {{ $t(servicio.texto) }}
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
/* Título responsive */
.titulo-principal {
  color: #FAD063;
  font-size: clamp(32px, 8vw, 70px);
  letter-spacing: 1px;
}

.mi-select ::v-deep .v-input__slot::before,
.mi-select ::v-deep .v-input__slot::after,
.mi-select ::v-deep .v-input--is-focused .v-input__slot::after {
  display: none !important;
  border-bottom: none !important;
}

.mi-select ::v-deep .v-select__slot {
  justify-content: center !important;
}

.mi-select ::v-deep .v-select__selection {
  text-align: center;
  width: 100%;
}

.mi-select ::v-deep .v-input__append-inner {
  display: none !important;
}

.prueba1 {
  position: relative;
  margin: 40px auto;
  width: 90%;
  max-width: 600px;
}

.prueba2 {
  position: absolute;
  top: -12px;
  left: 20px;
  background: #6d727a;
  color: #FAD063;
  padding: 0 8px;
  font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  display: inline-block;
  white-space: nowrap;
}

.selects-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 2px solid white;
  border-radius: 10px;
  overflow: hidden;
}

/* En pantallas medianas o más grandes, horizontal */
@media (min-width: 600px) {
  .selects-container {
    flex-direction: row;
  }
  
  .select-item + .select-item {
    border-left: 1px solid white;
    border-top: none;
  }
}

/* En móvil, vertical con separador horizontal */
@media (max-width: 599px) {
  .select-item + .select-item {
    border-top: 1px solid white;
  }
}

.select-item {
  flex: 1;
}

.select-item .v-input__slot::before,
.select-item .v-input__slot::after {
  display: none !important;
}

.mi-select ::v-deep .v-select__slot {
  justify-content: center !important;
}

.mi-select ::v-deep .v-select__placeholder {
  color: white !important;
  opacity: 1 !important;
}

.mi-select ::v-deep .v-select__selection {
  color: white !important;
}

body {
  font-family: 'Manrope';
}

.margeninferior {
  margin-bottom: 16px;
}

.fina {
  font-weight: 300 !important;
}

.infoAdicionaltarjeta {
  margin-top: 5px;
  font-size: 12px;
  color: rgb(128, 128, 128);
}
</style>

<script>
import api from "@/plugins/api";

export default {
  name: "PaginaInicio",

  computed: {
    form() {
      return {
        parkingseleccionado: this.parkingseleccionado
      };
    },
    labelDondeTeEncuentras() {
      return this.$t("labelInicio");
    },
    labelInicioDondeQuieresAparcar() {
      return this.$t("labelInicioDondeQuieresAparcar");
    },
    eligeCiudad() {
      return this.$t("eligeCiudad");
    },
    eligeParking() {
      return this.$t("eligeParking");
    },
    // Altura responsive para la imagen
    imagenHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '600px';
        case 'sm': return '650px';
        case 'md': return '750px';
        default: return '800px';
      }
    },
    // Espaciado superior responsive
    espaciadoSuperior() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '15%';
        case 'sm': return '18%';
        default: return '20%';
      }
    }
  },

  data: () => ({
    ciudadSeleccionada: '',
    serviciosParking: [
      { icono: "credit-card.png", texto: "serviciosPagoTarjeta" },
      { icono: "electric-car.png", texto: "electrico" },
      { icono: "accesominusvalidos.png", texto: "servicioPlazasMinusvalidos" },
      { icono: "full.png", texto: "serviciosAbierto" },
      { icono: "videovigilancia.png", texto: "servicioVideoVigilancia" },
      { icono: "energy.png", texto: "servicioCargaBateria" },
      { icono: "license.png", texto: "servicioLecturaMatricula" },
      { icono: "parking.png", texto: "serviciosPlazasAmplias" },
    ],
    tarjetas: [
      {
        icono: "mdi-shield-check",
        titulo: "inicioTituloPlazaGarantizada",
        descripcion: "inicioPlazaGarantizada",
      },
      {
        icono: "mdi-undo",
        titulo: "inicioTituloCancelacionReembolso",
        descripcion: "inicioCancelacionReembolso",
      },
      {
        icono: "mdi-tag",
        titulo: "inicioTituloAhorra",
        descripcion: "inicioAhorra",
      },
    ],
    parkingseleccionado: "",
    verParkings: true,
    itemsCiudad: [],
    datosParkingsDisponible: [],
    itemsParkings: [],
  }),

  methods: {
    cadenaTiempo: function (aTiempo) {
      return aTiempo + " " + this.$t("minutos");
    },

    obtenerDatosDeParkingsDisponibles() {
      api.obtenerDatosDeParkings().then((res) => {
        console.log(res);
        this.datosParkingsDisponible = res.data.datos;
        res.data.ciudades.forEach((element) => {
          this.itemsCiudad.push(element["ciu"]);
        });

        res.data.datos.forEach(element => {
          this.itemsParkings.push(element['nom'])
        });
      });
    },

    reservarEstancia() {
      if (this.parkingseleccionado !== "") {
        // Limpieza de los datos de localStorage
        window.localStorage.setItem("importeReserva", "");
        window.localStorage.setItem("importeReservaNumero", 0);
        window.localStorage.setItem("fechaEntrada", "");
        window.localStorage.setItem("fechaSalida", "");
        window.localStorage.setItem("horaSalida", "00:00");
        window.localStorage.setItem("horaEntrada", "00:00");
        window.localStorage.setItem("matricula", "");
        window.localStorage.setItem("modelo", "");
        window.localStorage.setItem("parking", this.parkingseleccionado);
        window.localStorage.setItem("ciudad", 'Granada');
        window.localStorage.setItem("nombre", "");
        window.localStorage.setItem("mail", "");
        window.localStorage.setItem("telefono", "");
        window.localStorage.setItem("cif", "");
        window.localStorage.setItem("direccion", "");
        window.localStorage.setItem("localidad", "");
        window.localStorage.setItem("cp", "");
        window.localStorage.setItem("nombreFac", "");
        window.localStorage.setItem("pais", "");
        window.localStorage.setItem("aceptacionTerminos", false);

        this.$router.push({ path: "/reservar" });
      }
    },
  },

  created() {
    this.obtenerDatosDeParkingsDisponibles();
  },

  watch: {
    parkingseleccionado() {
      if (this.parkingseleccionado != '') {
        this.reservarEstancia()
      }
    }
  },

  mounted: function () {
    window.scrollTo(0, 0);
  },
};
</script>